import { render, staticRenderFns } from "./immutable_badge.vue.js?vue&type=template&id=1d84f8f9!=!../../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./immutable_badge.vue?vue&type=template&id=1d84f8f9"
import script from "./immutable_badge.vue.js?vue&type=script&lang=js!=!../../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./immutable_badge.vue?vue&type=script&lang=js"
export * from "./immutable_badge.vue.js?vue&type=script&lang=js!=!../../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./immutable_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports